import { Api, ApiResponse } from "common";
import {
  GetUserAffiliateDetailsPayload,
  GetUserAffiliateTotalCustomersResponse,
  GetUserAffiliateTotalDiscountResponse,
  GetUserAffiliateTotalIncentivesResponse,
  GetUserAffiliateVouchersResponse,
} from "./types";

const getUserAffiliateVouchers =
  (): ApiResponse<GetUserAffiliateVouchersResponse> => {
    return Api.get(`api/ecomm/user/vouchers/get`);
  };

const getUserAffiliateTotalCustomers = (
  data: GetUserAffiliateDetailsPayload
): ApiResponse<GetUserAffiliateTotalCustomersResponse> => {
  const params = new URLSearchParams(data as Record<string, string>).toString();

  return Api.get(`api/ecomm/user/vouchers/total_customers/get?${params}`);
};

const getUserAffiliateTotalDiscount = (
  data: GetUserAffiliateDetailsPayload
): ApiResponse<GetUserAffiliateTotalDiscountResponse> => {
  const params = new URLSearchParams(data as Record<string, string>).toString();

  return Api.get(`api/ecomm/user/vouchers/total_discount/get?${params}`);
};

const getUserAffiliateTotalIncentives = (
  data: GetUserAffiliateDetailsPayload
): ApiResponse<GetUserAffiliateTotalIncentivesResponse> => {
  const params = new URLSearchParams(data as Record<string, string>).toString();

  return Api.get(`api/ecomm/user/vouchers/total_incentives/get?${params}`);
};

export const UserAffiliateApi = {
  getUserAffiliateVouchers,
  getUserAffiliateTotalCustomers,
  getUserAffiliateTotalDiscount,
  getUserAffiliateTotalIncentives,
};
